import { render, staticRenderFns } from "./ModalAspectos.vue?vue&type=template&id=4b4329f4&"
import script from "./ModalAspectos.vue?vue&type=script&lang=js&"
export * from "./ModalAspectos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports